import React from 'react';
import { CandidateWithSlides } from '../../lib/supabase';
import { getUniversity } from '../../lib/constants';
import ResearcherCard from './ResearcherCard';

interface UniversityColumnProps {
  universityId: string;
  candidates: CandidateWithSlides[];
  likeCounts: Record<string, number>;
  commentCounts: Record<string, number>;
  participateCounts: Record<string, number>;
  avgRatings: Record<string, number>;
  ratingCounts: Record<string, number>;
  mutedCandidates?: Set<string>;
  onToggleMute?: (candidateId: string) => void;
  onSelectCandidate: (candidate: CandidateWithSlides) => void;
}

export default function UniversityColumn({
  universityId,
  candidates,
  likeCounts,
  commentCounts,
  participateCounts,
  avgRatings,
  ratingCounts,
  mutedCandidates,
  onToggleMute,
  onSelectCandidate,
}: UniversityColumnProps) {
  const uni = getUniversity(universityId);

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className={`rounded-t-lg px-4 py-3 ${uni.color} text-white`}>
        <h3 className="font-bold text-base">{uni.name}</h3>
        <p className="text-sm opacity-90">{candidates.length} 件の研究発表</p>
      </div>

      {/* Card list */}
      <div className={`flex-1 rounded-b-lg border ${uni.borderColor} ${uni.lightBg} p-3 space-y-3 overflow-y-auto`} style={{ maxHeight: '75vh' }}>
        {candidates.length === 0 ? (
          <p className="text-center text-sm text-muted-foreground py-8">
            まだ研究発表がありません
          </p>
        ) : (
          candidates.map((c) => (
            <ResearcherCard
              key={c.id}
              candidate={c}
              likeCount={likeCounts[c.id] || 0}
              commentCount={commentCounts[c.id] || 0}
              participateCount={participateCounts[c.id] || 0}
              avgRating={avgRatings[c.id] || 0}
              ratingCount={ratingCounts[c.id] || 0}
              isMuted={mutedCandidates?.has(c.id)}
              onToggleMute={onToggleMute ? () => onToggleMute(c.id) : undefined}
              onClick={() => onSelectCandidate(c)}
            />
          ))
        )}
      </div>
    </div>
  );
}
